import { BaseApi } from '@/shared/api/baseApi';
import { ENTITY_CONFIGS } from '@/shared/constants/entities';

import type { PaymentRetry } from '../types';

const paymentRetriesApiInstance = new BaseApi<PaymentRetry, Partial<PaymentRetry>>(
  ENTITY_CONFIGS.paymentRetries.endpoints,
);

export const paymentRetriesApi = {
  getList: paymentRetriesApiInstance.getList.bind(paymentRetriesApiInstance),
  getOne: () => Promise.reject(new Error('Not implemented')),
  create: () => Promise.reject(new Error('Not implemented')),
  update: (id: number) => paymentRetriesApiInstance.update(id, { status: 'cancelled' }),
  delete: () => Promise.reject(new Error('Not implemented')),
};
